// DOM buttons are positioned in the native series render cycle, not a debounced
// range callback. This keeps focusable markers attached to their exact bars.
export class ChartingEngulfingMarkers {
    constructor(layer, onSelect) {
        this.layer = layer;
        this.onSelect = onSelect;
        this.entries = new Map();
        this.selectedId = null;
        this.hoveredId = null;
        this.size = null;
        this.views = [{ zOrder: () => 'bottom', renderer: () => this }];
    }
    attached({ chart, series, requestUpdate }) { Object.assign(this, { chart, series, requestUpdate }); }
    detached() {
        for (const entry of this.entries.values()) entry.button.remove();
        this.entries.clear();
        this.chart = this.series = this.requestUpdate = null;
    }
    paneViews() { return this.views; }
    setCandidates(candidates) {
        const ids = new Set(candidates.map(candidate => candidate.id));
        for (const [id, entry] of this.entries) {
            if (!ids.has(id)) { entry.button.remove(); this.entries.delete(id); }
        }
        for (const candidate of candidates) {
            if (!this.entries.has(candidate.id)) {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'charting-engulfing-marker';
                button.textContent = 'E';
                button.hidden = true;
                button.dataset.engulfingId = candidate.id;
                button.setAttribute('aria-haspopup', 'dialog');
                for (const type of ['pointerdown', 'mousedown', 'touchstart']) button.addEventListener(type, event => event.stopPropagation());
                button.addEventListener('click', event => { event.stopPropagation(); this.onSelect(this.entries.get(candidate.id).candidate, button); });
                for (const type of ['mouseenter', 'focus']) button.addEventListener(type, () => { this.hoveredId = candidate.id; this.requestUpdate?.(); });
                for (const type of ['mouseleave', 'blur']) button.addEventListener(type, () => { this.hoveredId = null; this.requestUpdate?.(); });
                this.layer.appendChild(button);
                this.entries.set(candidate.id, { button });
            }
            const entry = this.entries.get(candidate.id);
            entry.candidate = candidate;
            entry.button.title = `Envolvente mensual · ${candidate.monthLabel}${candidate.provisional ? ' · En formación' : ''}. Ver semanas.`;
            entry.button.setAttribute('aria-label', entry.button.title);
        }
        this.updateAllViews();
        this.requestUpdate?.();
    }
    setSelected(id) { this.selectedId = id; this.requestUpdate?.(); }
    updateAllViews() {
        if (!this.chart || !this.series || !this.size) return;
        for (const entry of this.entries.values()) {
            const { button, candidate } = entry;
            const x = this.chart.timeScale().timeToCoordinate(candidate.time);
            const highY = this.series.priceToCoordinate(candidate.bar.high);
            const visible = Number.isFinite(x) && Number.isFinite(highY) && x >= 14 && x <= this.size.width - 14 && highY >= 0 && highY < this.size.height;
            button.hidden = !visible;
            button.setAttribute('aria-expanded', String(this.selectedId === candidate.id));
            if (visible) {
                const y = Math.max(14, highY - 20);
                button.style.transform = `translate(${x - 13}px, ${y - 13}px)`;
                entry.x = x;
            }
        }
    }
    draw(target) {
        target.useMediaCoordinateSpace(({ context, mediaSize }) => {
            this.size = mediaSize;
            this.updateAllViews();
            const active = this.entries.get(this.hoveredId || this.selectedId);
            if (!active || active.button.hidden) return;
            const width = Math.max(8, Math.min(56, this.chart.timeScale().options().barSpacing * 0.9));
            context.save();
            context.fillStyle = 'rgba(139, 92, 246, 0.09)';
            context.fillRect(active.x - width / 2, 0, width, mediaSize.height);
            context.restore();
        });
    }
}
